<template>
  <div v-loading="loading"
       class="app-listing-args">
    <div class="args">
      <app-operation-state-args
          :tags="operationStateTags"
          @refresh="refresh"
      ></app-operation-state-args>
    </div>
    <div class="args">
      <app-operation-log-args
          :tags="operationLogTags"
          @refresh="refresh"
      ></app-operation-log-args>
    </div>
  </div>
</template>

<script>
  import AppOperationStateArgs from "./components/operation-state-args";
  import AppOperationLogArgs from "./components/operation-log-args";
  import {getListingSetting} from "../../../../../../api/system";
  import {isMeaningful} from "../../../../../../utils/common";
  export default {
    name: "app-listing-args",
    components: {AppOperationLogArgs, AppOperationStateArgs},
    data() {
      return {
        operationStateTags: [],
        operationLogTags: [],
        loading: false
      }
    },
    created() {
      this.refresh();
    },
    methods: {
      refresh() {
        this.loading = true;
        getListingSetting()
          .then((data) => {
            if (isMeaningful(data)) {
              this.operationStateTags = data.find(item => item.type === 'OPERATION_STATE').dictionaryList;
              this.operationLogTags = data.find(item => item.type === 'OPERATION_LOG_TYPE').dictionaryList;
            }
          })
          .complete(() => this.loading = false);
      }
    }
  }
</script>

<style scoped>
  .app-listing-args {
    height: 100%;
    box-sizing: border-box;
    padding: 0 10px 10px;
  }
  .args {
    margin-bottom: 20px;
  }
</style>
